exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "small[data-v-70c27001],\n.small[data-v-70c27001] {\n  font-size: 90% !important;\n}\n", ""]);

// exports
